import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { collection, getDocs } from 'firebase/firestore';
import { doc, setDoc } from "firebase/firestore";
import { db } from '../firebase';
import { useNavigate } from "react-router-dom";
import { User } from './Dashboard'

export interface UserData {
    email: string | null;
    displayName: string | null;
    uid: string;
    secretsanta?: string
    joined: boolean
}

export interface Event {
    uid: string,
    owner: UserData | null,
    members: UserData[],
    name: string,
    picked: boolean,
    createdAt: string
}

export default function Create() {
    const [user_names, setUser_names] = useState<User[]>([]);
    const [event_users, setEvent_users] = useState<User[]>([]);
    const [addedUserEmail, setAddedUserEmail] = useState<string>("")
    const currentUser = useAuth().currentUser
    const navigate = useNavigate();
    const [event, setEvent] = useState<Event>({
        uid: "",
        owner: null,
        members: [],
        name: "",
        picked: false,
        createdAt: ""
    })

    useEffect(() => {
        async function fetchUsers() {
            const usersSnapshot = await getDocs(collection(db, 'users'));
            const users: User[] = [];
            usersSnapshot.forEach((doc) => {
                const userData = doc.data() as User;
                users.push(userData);
            });
            setUser_names(users);
        }
        fetchUsers();
    }, []);

    // Helper function to convert User to plain object
    function userToPlainObject(user: any, secretsanta?: string): UserData {
        return {
            uid: user.uid,
            displayName: user.displayName,
            email: user.email,
            secretsanta: secretsanta || "",
            joined: false,
        };
    }


    async function MakeEvent() {
        if (!event.name || event.name.trim() === "") {
            alert("Yo, you must provide an event name!");
            return;
        }
        if (!currentUser) {
            alert("Yo, this is so null is an impossible value for owner!");
            return;
        }
        if (event_users.length <= 2 ) {
            alert("Yo, you must have more than one member")
            return;
        }

        const eventId = doc(collection(db, 'events')).id

        const ownerAsParticipant = {
            ...userToPlainObject(currentUser),
            joined: true
        };

        const event_with_details = {
            uid: eventId,
            owner: userToPlainObject(currentUser),
            members: [
                ...event_users.map((user) => userToPlainObject(user)),
                ownerAsParticipant
            ],
            name: event.name,
            picked: false,
            createdAt: new Date().toISOString()
        }

        await setDoc(doc(db, 'events', eventId), event_with_details);
        
        navigate('/dashboard')
        alert("Event created successfully!");
    }

    function AddUserToMembers(useremail: string) {
        var user_to_be_added = user_names.find(user => user.email === useremail)
        if (user_to_be_added === undefined) {
            alert("No such email saved in the database")
            return
        }else if (user_to_be_added?.uid === currentUser?.uid){
            alert("Yo, the owner is automatically added")
            return
        }else{
            const res: boolean = event_users
                .map(user => JSON.stringify(user))
                .includes(JSON.stringify(user_to_be_added))
            let new_list: User[];
            if (res) {
                alert("Member Already Added")
                return
            } else {
                new_list = [...event_users, user_to_be_added]
            }
            setEvent_users(new_list)
            alert("Member successfully added")
        }

    }

    function TakeOutUserFromMembers(addedemail: string) {
        var user_to_be_deleted = user_names.find(user => user.email === addedemail)
         if (user_to_be_deleted === undefined) {
            alert("No such email saved in the database")
            return
        }else if (user_to_be_deleted?.uid === currentUser?.uid){
            alert("Yo, do not delete the Owner")
            return
        } else {
            const res: boolean = event_users
                .map(user => JSON.stringify(user))
                .includes(JSON.stringify(user_to_be_deleted))
            let new_list: User[];
            if (res) {
                new_list = event_users.filter(element => element !== user_to_be_deleted)
            } else {
                alert("This User is not currently a member")
                return
            }
            setEvent_users(new_list)
            alert("Member successfully deleted")
        }

    }

    function Display_chosen_member({ member, index }: { member: User, index: number }) {
        return (
            <li key={index} style={{
                padding: '8px',
                marginBottom: '5px',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
            >
                <span>{member.displayName || member.email}</span>
                {currentUser?.uid !== member.uid && <button
                    onClick={() => TakeOutUserFromMembers(member.email || '')}
                    style={{
                        padding: '4px 8px',
                        backgroundColor: '#C71212',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Remove
                </button>}
            </li>
        )
    }

    return (
        <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px' }}>
            <h1>Create Event</h1>
            <div style={{ marginBottom: '15px' }}>
                <input
                    type="text"
                    placeholder="Event Name"
                    value={event.name}
                    onChange={(e) => setEvent({ ...event, name: e.target.value })}
                    style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                />
            </div>
            <h2>Select Members by Email</h2>
            <form onSubmit={(e) => {
                e.preventDefault();
                AddUserToMembers(addedUserEmail);
            }}
            >
                <input
                    type="text"
                    autoCapitalize="off"
                    value={addedUserEmail}
                    onChange={(e) => setAddedUserEmail(e.target.value)}
                    style={{ width: '100%', padding: '8px', margin: '5px'}}
                />
                <button
                    type="submit"
                    style={{
                        width: '100%',
                        padding: '10px',
                        backgroundColor: '#109433',
                        color: 'white',
                        border: 'none',
                        margin: '5px'
                    }}
                >
                    Add Selected Member
                </button>
            </form>
            {event_users.length > 0 && (
                <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                    <h3>Members:</h3>
                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                        {event_users.map((user, index) => (
                            <Display_chosen_member
                                member={user}
                                index={index}
                            />
                        ))}
                    </ul>
                </div>
            )}
            <button
                onClick={() => MakeEvent()}
                style={{
                    width: '100%',
                    padding: '10px',
                    backgroundColor: '#109433',
                    color: 'white',
                    border: 'none',
                    margin: '5px'
                }}
            >
                Make Event
            </button>
        </div>
    );
}